// 공지/점검 노출 판단에 쓰이는 "현재 시각" 단일 진입점.
//
// dev/staging 에서는 localStorage 오버라이드 값을 반영해, 실제 그 시각이 되지 않아도
// notice_period / blackout_period 진입·이탈 동작을 reload 기반으로 미리 확인할 수 있다.
// 운영 빌드에서는 __ENV_PRODUCTION__ 가드로 오버라이드 경로가 제거되어 항상 실제 시각을 쓴다.
//
// 우선순위(dev): localStorage setNow(콘솔/e2e) > 코드 상수 DEV_NOW_OVERRIDE(임시 강제) > 실제 시각.
// 사용: window.__OMA_TEST__.maintenance.setNow('2026-07-03T20:00:00Z') 후 새로고침

import { DEV_NOW_OVERRIDE } from './devScenario'

const NOW_OVERRIDE_KEY = 'officemail.maintenance.devNowOverride'

/** 판단 기준 현재 시각. dev 오버라이드(localStorage > 코드 상수)가 유효하면 그 값을, 아니면 실제 시각을 반환. */
export function getMaintenanceNow(): Date {
  if (!__ENV_PRODUCTION__) {
    try {
      const raw = localStorage.getItem(NOW_OVERRIDE_KEY)
      if (raw) {
        const overridden = new Date(raw)
        if (!Number.isNaN(overridden.getTime())) return overridden
      }
    } catch {
      // localStorage 접근 불가 시 다음 폴백으로 진행.
    }
    if (DEV_NOW_OVERRIDE) {
      const fromCode = new Date(DEV_NOW_OVERRIDE)
      if (!Number.isNaN(fromCode.getTime())) return fromCode
    }
  }
  return new Date()
}

/** dev 시간 오버라이드 설정/해제. null 이면 해제. 운영 빌드에서는 getMaintenanceNow 가 무시한다. */
export function setMaintenanceNowOverride(value: string | null): void {
  try {
    if (value) localStorage.setItem(NOW_OVERRIDE_KEY, value)
    else localStorage.removeItem(NOW_OVERRIDE_KEY)
  } catch {
    // 저장 불가 시 무시.
  }
}

/** 현재 설정된 dev 시간 오버라이드 값(없으면 null). */
export function getMaintenanceNowOverride(): string | null {
  try {
    return localStorage.getItem(NOW_OVERRIDE_KEY)
  } catch {
    return null
  }
}
